function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

export const nFormatter = (num) => {
  if (num >= 1000000000) {
    console.log("very large");
    const isFloatFlag = isFloat(num / 1000000000);
    const isE = (num / 1000000000).toString().includes("e");
    return isE
      ? (num / 1000000000).toExponential(2).replace(/\.0$/, "") + ""
      : (num / 1000000000).toFixed(isFloatFlag ? 2 : 1).replace(/\.0$/, "") +
      "B";
  }
  if (num >= 1000000) {
    const isFloatFlag = isFloat(num / 1000000);
    return (
      (num / 1000000).toFixed(isFloatFlag ? 2 : 1).replace(/\.0$/, "") + "M"
    );
  }
  if (num >= 1000) {
    const isFloatFlag = isFloat(num / 1000);
    return (num / 1000).toFixed(isFloatFlag ? 2 : 1).replace(/\.0$/, "") + "K";
  }
  return Math.round(num, 2);
};
